import { create } from "zustand";
import { getCookies } from "../helpers/commonFunctions";
import { LiteUserInfo } from "../interfaces/appAndPayload/AppInterface";
import { Toast } from "../interfaces/globalTypes/GlobalTypes.type";

type State = {
  userInfo: LiteUserInfo;
  language: string;
  ecountry: string;
  device_uuid: string;
  token: string;
  isDeviceMobile: boolean;
};

type Actions = {
  setToken: (token: string) => void
}

const useAppStore = create<State & Actions>((set) => ({
  userInfo: getCookies().userInfo,
  language: getCookies().NEXT_LOCALE,
  ecountry: getCookies().ecountry,
  isDeviceMobile: getCookies().source == "mobile",
  device_uuid: getCookies().device_uuid,
  token : "",
  setToken: (token: string) => {
    set((state) => ({
      token : token
    }))
  }}
));

export default useAppStore;
